import React, { useCallback } from "react";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import Container from "@material-ui/core/Container";
import useMedia from "use-media";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";
import Toolbar from "@material-ui/core/Toolbar";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://torememo-7b555.web.app/top">
        torememo
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 2,
    backgroundColor: "#ffffff",
  },
  toolbar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbarTitle: {
    flex: 1,
  },
  toolbarSecondary: {
    justifyContent: "space-between",
    overflowX: "auto",
  },
  toolbarLink: {
    padding: theme.spacing(1),
    flexShrink: 0,
  },
  title: {
    textShadow: "6px 2px 3px #c0c0c0",
  },
  titleRes: {
    textShadow: "6px 2px 3px #c0c0c0",
    fontSize: 46,
  },
  login: {
    background: "#3399ff",
    padding: theme.spacing(1, 5),
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#000066",
    },
  },
  main: {
    position: "relative",
    height: "auto",
  },
  hero: {
    backgroundImage: "url(https://source.unsplash.com/eGSBVVtVCCw)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100%",
    width: "100%",
    zIndex: 0,
  },
  heroContainer: {
    // height: 1100,
  },
  heroContents: {
    paddingTop: "330px",
    fontSize: 30,
  },
  heroSubContents: {
    marginTop: 320,
  },
  heroSubContentsText: {
    padding: theme.spacing(5),
    lineHeight: 2,
  },
  icon: {
    display: "block",
    height: 30,
    width: 30,
    paddingRight: theme.spacing(2),
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
  },
  footer: {
    marginTop: "auto",
    width: "100%",
    position: "unset",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
  footerText: {
    padding: theme.spacing(4, 3),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700],
  },
  cardText: {},
  cardWrap: {
    padding: theme.spacing(13, 0),
  },
  cardBorder: {
    borderRadius: 20,
  },
  cardWrapTitle: {
    textAlign: "center",
    paddingBottom: theme.spacing(5),
    fontSize: 40,
  },
  cardWrapTitleRes: {
    textAlign: "center",
    paddingBottom: theme.spacing(5),
    fontSize: 28,
  },
  imgContainer: {
    height: 250,
    width: 250,
    margin: "10px auto",
  },
  img: {
    height: "100%",
    width: "100%",
  },
  cardTitle: {
    textAlign: "center",
    paddingBottom: theme.spacing(1),
    fontWeight: "bold",
  },
  stepImg: {
    height: "100%",
    width: "100%",
  },
  stepImgText: {
    textAlign: "center",
  },
  mainImgContainer: {
    height: 700,
    width: 350,
    position: "absolute",
    top: 300,
    right: 200,
  },
  padding: {
    padding: theme.spacing(2),
  },
  stepContainer: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(6, 0),
  },
  stepSectionBack: {
    backgroundColor: "#f6f5f4",
  },
  stepSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    padding: theme.spacing(5, 0),
  },
  stepText: {
    backgroundColor: "#3399ff",
    color: "#ffffff",
    padding: 50,
    borderRadius: 10,
  },
  stepSubText: {
    display: "flex",
    justifyContent: "center",
    fontSize: 14,
  },
  stepTextRes: {
    backgroundColor: "#3399ff",
    color: "#ffffff",
    padding: "50px 20px",
    borderRadius: 10,
  },
  stepButton: {
    background: "#0033cc",
    marginTop: 25,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#000066",
    },
  },
  stepTextSize: {
    fontSize: 40,
  },
  stepTitle: {
    fontSize: 40,
    fontWeight: "bold",
  },
  stepTitleRes: {
    fontSize: 28,
    fontWeight: "bold",
  },
  banner: {
    padding: theme.spacing(9, 0),
  },
  bannerRes: {
    padding: theme.spacing(9, 0),
    flexWrap: "wrap",
    justifyContent: "center",
  },
  bannerTextMain: {
    color: "#3399ff",
    fontSize: 30,
  },
  bannerText: {
    paddingTop: theme.spacing(2),
  },
  bannerButton: {
    background: "#3399ff",
    marginTop: 25,
    color: "#ffffff",
    padding: "15px 60px",
    "&:hover": {
      backgroundColor: "#000066",
    },
  },
  qr: {
    height: 100,
    width: 100,
  },
  heroTextWrap: {
    backgroundColor: "rgba(254,255,255,0.5)",
    borderRadius: 15,
  },
  textRes: {
    fontSize: 15,
    textAlign: "center",
  },
}));

const tiers = [
  {
    title: "参考になる",
    text: "身長や体重が近いユーザーを検索することができます。他のトレーニーのメニューを参考にして、トレーニングを充実させよう！",
    img: `${window.location.origin}/sampleSearch.png`,
    buttonVariant: "outlined",
  },
  {
    title: "ひと目で分かる",
    text: "月ごとのトレーニングをひと目で確認できます。効率の良いトレーニングサイクルを導き出そう！",
    img: `${window.location.origin}/sampleCalendar.png`,

    buttonVariant: "contained",
  },
  {
    title: "記録が簡単",
    text: "簡単操作で瞬時に記録ができます。面倒なトレーニング管理は全てtorememoにおまかせください！",
    img: `${window.location.origin}/sampleCreate.png`,

    buttonVariant: "outlined",
  },
];

const Auth: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const isWide = useMedia({ minWidth: "1025px" });
  const goLogin = useCallback(() => {
    history.push("/login");
  }, []);

  return (
    <Grid container>
      {/* <Grid item xs={false} sm={4} md={7} className={classes.image} /> */}
      <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square>
        <header className={classes.header}>
          <Toolbar className={classes.toolbar}>
            <Typography
              component="h2"
              variant="h5"
              color="inherit"
              //   align="center"

              className={classes.toolbarTitle}
            >
              <div className={classes.iconContainer}>
                <span className={classes.icon}>
                  <img
                    src={`${window.location.origin}/logo192.png`}
                    alt=""
                    className={classes.stepImg}
                  />
                </span>
                <span>torememo</span>
              </div>
            </Typography>

            <Button
              variant="outlined"
              size="small"
              className={classes.login}
              onClick={goLogin}
            >
              LOGIN
            </Button>
          </Toolbar>
        </header>
        <main className={classes.main}>
          <div className={classes.heroContainer}>
            <div className={classes.hero}>
              <Container className={classes.heroContents}>
                <h1 className={isWide ? classes.title : classes.titleRes}>
                  トレーニングの質を上げる。
                </h1>
              </Container>
              <Container className={classes.heroSubContents}>
                {isWide ? (
                  <Grid container>
                    <Grid item>
                      <div className={classes.mainImgContainer}>
                        <img
                          src={`${window.location.origin}/iphone.png`}
                          alt=""
                          className={classes.stepImg}
                        />
                      </div>
                    </Grid>
                  </Grid>
                ) : (
                  ""
                )}

                <Paper className={classes.heroTextWrap}>
                  <div className={classes.heroSubContentsText}>
                    <span className={classes.bannerTextMain}>torememo</span> は
                    "使いやすさ" に特化した筋トレ管理アプリです。
                    <br />
                    スマホでの簡単操作で、毎日のトレーニングを瞬時に記録することができます。
                    <br />
                    {/* 豊富なトレーニングメニューが備わっているため、初級者の方から上級者の方まで幅広くお使いいただけます。 */}
                    <br />
                    トレーニングの記録を共有できるため、他のユーザーを参考にしたメニューの組み立てが可能です!
                    <br />
                    "上級者の方"はもちろん、
                    "何をすればいいかわからない初級者の方"、
                    "モチベーションが続かない方"でも
                    <br />
                    毎日の記録をシェアしながら、充実したトレーニングライフを楽しみましょう！
                  </div>
                </Paper>
              </Container>
            </div>
          </div>
          <Container maxWidth="md">
            <div className={classes.cardWrap}>
              <h2
                className={
                  isWide ? classes.cardWrapTitle : classes.cardWrapTitleRes
                }
              >
                あなたのトレーニングライフをサポートします
              </h2>
              <Grid container spacing={5} alignItems="flex-end">
                {tiers.map((tier) => (
                  <Grid
                    item
                    key={tier.title}
                    xs={12}
                    sm={tier.title === "Enterprise" ? 12 : 6}
                    md={4}
                  >
                    <Card className={classes.cardBorder}>
                      <div className={classes.imgContainer}>
                        <img
                          src={tier.img}
                          className={classes.img}
                          alt={`${tier.title}の画像`}
                        />
                      </div>

                      <CardContent>
                        <div className={classes.cardText}>
                          <Typography
                            variant="h6"
                            color="primary"
                            component="h2"
                            className={classes.cardTitle}
                          >
                            {tier.title}
                          </Typography>
                          <Typography
                            variant="caption"
                            component="p"
                            color="textPrimary"
                          >
                            {tier.text}
                          </Typography>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </div>
          </Container>
          <div className={classes.stepContainer}>
            <div>
              <div>
                <div className={classes.padding}>
                  <Typography
                    variant="h3"
                    align="center"
                    className={
                      isWide ? classes.stepTitle : classes.stepTitleRes
                    }
                  >
                    ご利用までの3STEP
                  </Typography>
                  <Typography
                    variant="h6"
                    align="center"
                    className={
                      isWide
                        ? classes.padding
                        : classes.padding + " " + classes.textRes
                    }
                  >
                    以下の操作でスマホアプリのようにご利用が可能です。
                    <br />
                    本サービスはスマホでのご利用を想定しておりますが、PCからのご利用も可能です。
                  </Typography>
                  <div className={classes.stepSubText}>
                    <div>
                      ※以下のブラウザに対応しています。 <br />
                      　safari 14.1以上　,　Google Chrome 91以上
                    </div>
                  </div>
                </div>
                <Container>
                  <Grid container className={classes.stepSection}>
                    <Grid
                      item
                      xs={6}
                      className={
                        isWide ? classes.stepText : classes.stepTextRes
                      }
                    >
                      <Box
                        display="flex"
                        alignItems="flex-end"
                        justifyContent="space-between"
                      >
                        <div>
                          <h3 className={classes.stepTextSize}>
                            Step <span>01</span>
                          </h3>
                          <div>
                            ログインページを開き、右画面のボタンをタップする
                          </div>
                        </div>
                        {isWide ? (
                          <div>
                            <div className={classes.qr}>
                              <img
                                src={`${window.location.origin}/torememo.png`}
                                alt=""
                                className={classes.stepImg}
                              />
                            </div>
                            {/* <Button className={classes.stepButton}>
                            ログイン画面
                          </Button> */}
                          </div>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/iphonePoint1.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>iPhone</div>
                          </div>
                        </Grid>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/androidPoint1.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>Android</div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Container>
                <Container>
                  <Grid container className={classes.stepSection}>
                    <Grid
                      item
                      xs={6}
                      className={
                        isWide ? classes.stepText : classes.stepTextRes
                      }
                    >
                      <h3 className={classes.stepTextSize}>
                        Step <span>02</span>
                      </h3>
                      <div>ホーム画面に追加をタップする</div>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/iphonePoint2.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>iPhone</div>
                          </div>
                        </Grid>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/androidPoint2.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>Android</div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Container>
                <Container>
                  <Grid container className={classes.stepSection}>
                    <Grid
                      item
                      xs={6}
                      className={
                        isWide ? classes.stepText : classes.stepTextRes
                      }
                    >
                      <h3 className={classes.stepTextSize}>
                        Step <span>03</span>
                      </h3>
                      <div>ホーム画面のアイコンから起動する</div>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/iphonePoint3.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>iPhone</div>
                          </div>
                        </Grid>
                        <Grid item xs={6} md={6}>
                          <div>
                            <img
                              src={`${window.location.origin}/androidPoint3.png`}
                              alt=""
                              className={classes.stepImg}
                            />
                            <div className={classes.stepImgText}>Android</div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Container>
              </div>
            </div>
          </div>
          <Container maxWidth="md">
            <Box
              display="flex"
              justifyContent="space-between"
              className={isWide ? classes.banner : classes.bannerRes}
              alignItems="flex-end"
            >
              <div>
                <div>トレーニングの記録までも楽しくし、効率よく管理する。</div>
                <div className={classes.bannerText}>
                  皆様の成長と共に
                  <span className={classes.bannerTextMain}>torememo</span>
                  も成長を続けます。
                </div>
              </div>
              <div>
                <Button className={classes.bannerButton} onClick={goLogin}>
                  今すぐ始める
                </Button>
              </div>
            </Box>
          </Container>
        </main>
        <footer className={classes.footer}>
          <div className={classes.footerText}>
            <Container maxWidth="sm">
              <Typography variant="body1">
                Training management application
              </Typography>
              <Copyright />
            </Container>
          </div>
        </footer>
      </Grid>
    </Grid>
  );
};

export default Auth;
